import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SuccessFrameworkSection from '../components/SuccessFrameworkSection';
import { Target, TrendingUp, Users, Award } from 'lucide-react';

const OurFrameworkPage = () => {
  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      <Header />
      
      {/* Hero Section */}
      <section className="py-24 bg-gradient-to-br from-indigo-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-block mb-6">
            <span className="bg-indigo-100 text-indigo-700 px-6 py-2 rounded-full text-sm font-semibold">
              OUR FRAMEWORK
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6 leading-tight">
            The CareerLift Success Framework™
          </h1>
          <p className="text-xl text-slate-600 max-w-4xl mx-auto leading-relaxed mb-8">
            A proven 4-step journey from confusion to career confidence. Not just courses—a complete transformation system.
          </p>
        </div>
      </section>

      {/* Why Framework Matters */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-indigo-700 rounded-3xl p-12 text-white mb-16">
            <h2 className="text-3xl font-bold mb-6 text-center">Why a Framework Matters</h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-xl font-bold mb-3">❌ Without a Framework:</h3>
                <ul className="space-y-2 text-indigo-100">
                  <li>• Jumping between random tutorials</li>
                  <li>• No clear direction or end goal</li>
                  <li>• Learning disconnected skills</li>
                  <li>• Feeling overwhelmed and lost</li>
                  <li>• Wasting time and money</li>
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-bold mb-3">✅ With Our Framework:</h3>
                <ul className="space-y-2 text-indigo-100">
                  <li>• Clear step-by-step path</li>
                  <li>• Know exactly what's next</li>
                  <li>• Build connected, job-ready skills</li>
                  <li>• Confidence at every stage</li>
                  <li>• Guaranteed progress toward employment</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Framework Principles */}
          <div className="mb-20">
            <h2 className="text-4xl font-bold text-center text-slate-900 mb-12">Built on 4 Core Principles</h2>
            <div className="grid md:grid-cols-4 gap-6">
              <div className="bg-gradient-to-br from-indigo-50 to-white rounded-2xl p-6 text-center border border-indigo-100">
                <div className="w-16 h-16 bg-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Target className="w-8 h-8 text-white" />
                </div>
                <h3 className="font-bold text-slate-900 mb-2">1. Clarity</h3>
                <p className="text-sm text-slate-600">Know exactly where you're going and why</p>
              </div>
              
              <div className="bg-gradient-to-br from-indigo-50 to-white rounded-2xl p-6 text-center border border-indigo-100">
                <div className="w-16 h-16 bg-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <TrendingUp className="w-8 h-8 text-white" />
                </div>
                <h3 className="font-bold text-slate-900 mb-2">2. Progress</h3>
                <p className="text-sm text-slate-600">Measurable milestones at every step</p>
              </div>
              
              <div className="bg-gradient-to-br from-green-50 to-white rounded-2xl p-6 text-center border border-green-100">
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="w-8 h-8 text-white" />
                </div>
                <h3 className="font-bold text-slate-900 mb-2">3. Support</h3>
                <p className="text-sm text-slate-600">Never feel alone on your journey</p>
              </div>
              
              <div className="bg-gradient-to-br from-amber-50 to-white rounded-2xl p-6 text-center border border-amber-100">
                <div className="w-16 h-16 bg-amber-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="w-8 h-8 text-white" />
                </div>
                <h3 className="font-bold text-slate-900 mb-2">4. Results</h3>
                <p className="text-sm text-slate-600">Real jobs, real outcomes, real success</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SuccessFrameworkSection />
      
      {/* CTA */}
      <section className="py-20 bg-indigo-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Ready to Follow the Framework?</h2>
          <p className="text-xl text-indigo-100 mb-8">Join the students already transforming their careers with our proven system</p>
          <button onClick={() => window.location.href = '/contact'} className="bg-white text-indigo-700 font-semibold px-12 py-4 rounded-md hover:bg-gray-50 transition-colors duration-300">Start Your Journey Today</button>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default OurFrameworkPage;
